// extracted by mini-css-extract-plugin
export default {"DubbingSectionContainer":"DubbingSection_DubbingSectionContainer__quQM5"};